import { Union } from "./fable_modules/fable-library-js.4.19.0/Types.js";
import { union_type, string_type } from "./fable_modules/fable-library-js.4.19.0/Reflection.js";
import { Video } from "../Bfs.Web.Portale/Types.fs.js";

export class Filter extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["Alle", "NurNeue", "Kategorie"];
    }
}

export function Filter_$reflection() {
    return union_type("Kundenportal.Types.Filter", [], Filter, () => [[], [], [["Item", string_type]]]);
}

export const Video_Quickfinder = new Video("594551227");

//# sourceMappingURL=Kundenportal.Types.fs.js.map
